









































import {Component, Mixins, Watch, Prop, Ref} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import isBizRNum from '@/validate/is-biz-r-num'
import BttPopup from '@/components/popup/btt/BttPopup.vue'
import {Form, FormItem, Input} from 'element-ui'
import {mask} from 'vue-the-mask'
import {namespace} from 'vuex-class'

const userAgent = namespace('userAgent')

@Component({
  components: {
    BttPopup,
    [Form.name]: Form, [FormItem.name]: FormItem, [Input.name]: Input,
  },
  directives: {mask},
})

export default class BizRNumFormPopup extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) value: boolean

  @Ref('formRef') readonly formRef!: Form
  @Ref('inputRef') readonly inputRef!: Input

  @userAgent.Getter('isIE') isIE: boolean

  open: boolean = false
  registrationNumber: string = ''
  loading: boolean = false
  readonly bizRNumLength: number = 10

  get rules() {
    const {ts} = this
    return {
      registrationNumber: [
        {
          required: true,
          validator: (_, value, callback) => {
            if(!value) {
              return callback(new Error(`${ts('biz-no')}를 ${ts('input')}해주세요`))
            }
            if(value.length !== this.bizRNumLength) {
              return callback(new Error(`${this.bizRNumLength}자리의 ${ts('biz-no')}를 ${ts('input')}해주세요`))
            }
            if(!isBizRNum(value)) {
              return callback(new Error(`${ts('biz-no')}를 올바르게 ${ts('input')}해주세요`))
            }
            return callback()
          },
          trigger: ['blur', 'change'],
        }
      ],
    }
  }

  @Watch('value', {immediate: true})
  __value(value) {
    this.open = value
    this.formRef?.resetFields()
    this.formRef?.clearValidate()
  }

  onOpened() {
    this.inputRef?.focus()
  }

  onHandlePopup(value) {
    this.$emit('input', value)
  }

  onEnterBizRNum() {
    this.formRef.validate()
      .then((valid) => {
        if(valid) {
          this.$emit('enter-registration-number', this.registrationNumber)
        }
      })
      .catch((e) => e)
  }
}
